import type { UserStatus } from '@/types/models';

const enumMap = { Invited: 1, Active: 2, Inactive: 3, Locked: 4 } as const;

export type UserStatusEnumKeys = keyof typeof enumMap;
export type UserStatusEnumValues = (typeof enumMap)[UserStatusEnumKeys];

export const userStatusEnum: UserStatus extends UserStatusEnumValues
    ? typeof enumMap
    : never = enumMap;
